var render, staticRenderFns
import script from "./lemon-message-text.vue?vue&type=script&lang=js"
export * from "./lemon-message-text.vue?vue&type=script&lang=js"
import style0 from "./lemon-message-text.vue?vue&type=style&index=0&id=3b8fe30d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8fe30d",
  null
  
)

export default component.exports